type SwitchProps = {
  checked: boolean;
  onChange: () => void;
  srLabel?: string;
  disabled?: boolean;
};

export default function Switch({
  checked,
  onChange,
  srLabel = "Toggle option",
  disabled = false,
}: SwitchProps) {
  const trackClasses = checked ? "bg-primary" : "bg-default-200";
  const thumbClasses = checked ? "translate-x-5" : "translate-x-1";

  return (
    <button
      dir="ltr"
      type="button"
      onClick={disabled ? undefined : onChange}
      aria-pressed={checked}
      aria-label={srLabel}
      disabled={disabled}
      className={`relative inline-flex h-7 w-11 shrink-0 items-center rounded-full transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:cursor-not-allowed disabled:opacity-50 ${trackClasses}`}
    >
      <span className="sr-only">{srLabel}</span>
      <span
        aria-hidden="true"
        className={`inline-block h-5 w-5 transform rounded-full bg-background shadow transition ${thumbClasses}`}
      />
    </button>
  );
}
